import { baseBackend } from "../base/baseUrl";

const URL_BACKUP = "/api/v1/backup-order/create";
const URL_BACKUP_BOOKING_STATUS = "/api/v1/backup-order/booking-status";

export const createBackup = async (booking) => {
  return await baseBackend.post(URL_BACKUP, JSON.stringify({ booking }), {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateBackupBookingStatus = async ({ id, bookingStatus }) => {
  return await baseBackend.put(
    URL_BACKUP_BOOKING_STATUS,
    JSON.stringify({ id, bookingStatus }),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
